import { track } from './src/utilities';
import './src/styles/global.css';

export const onRouteUpdate = ({ location }) => {
  track('Page view', { path: location.pathname });
};
